
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gZpJGrxusD0YfgulH7Jw4EGEnuoXQn1FGsL4Ca5T37REMeta } from "/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexFU_45NV5PqKoOUbkHpfs1C8eUEcRZZExaE36c1z2BgL8wMeta } from "/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchvrILj3wtuHZOYpzpKrTollYo5oloKbLWLspn_45eGWdsAMeta } from "/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index9BQjZ2rPCX3SJ3lMdkyeP3297grq8ysmVeWzw1tozhkMeta } from "/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93k0Bo7nXfmEcB9hYfXLQB13wfh6uWgLxXRxn7UaugkS8Meta } from "/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexyaCULtG8AETnNaQnFkXWIhv8LVX9UFVtPa1Mh6bX_45TAMeta } from "/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_930dP1ieNaQxjT1RTmNdYDXDxXsg9ZvFu9Uh6zRoX0DWQMeta } from "/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index6vq0VQhsw53XQixpF7pk1Z3PPRfJ5gErleqlCOi2tf8Meta } from "/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93y4n3zkhOMFZlOHMMI8PWuq3_8ckSuoq3hRwIfIGRGNIMeta } from "/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index4OYyM_nIehM36bozFrMrn8TjqPuhJZcC_45AdEbpTqrJcMeta } from "/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index4df8XEN1YCXdHbehIPsYV6yM4MDZI_3GmeppEU1qBnMMeta } from "/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexyaCULtG8AETnNaQnFkXWIhv8LVX9UFVtPa1Mh6bX_45TAMeta || {},
    component: () => import("/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index6vq0VQhsw53XQixpF7pk1Z3PPRfJ5gErleqlCOi2tf8Meta || {},
    component: () => import("/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index4OYyM_nIehM36bozFrMrn8TjqPuhJZcC_45AdEbpTqrJcMeta || {},
    component: () => import("/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index4df8XEN1YCXdHbehIPsYV6yM4MDZI_3GmeppEU1qBnMMeta || {},
    component: () => import("/codebuild/output/src2283435133/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]